import React from 'react';
import { string, func } from 'prop-types';

/**
 * @private
 * @memberof nr-omni-shipping-pickup
 * @description Renders a link to open shipping customization modal.  The link contents will either be a postal code, or a call to action message
 *
 * @param {object} props - react component props
 * @param {string} props.postalCodeOrStoreName - postal code or storeName
 * @param {Function} props.toOrAtMessage - message shown to convey to or at
 * @param {Function} props.fallbackMessage - default call to action in case postalCode or storeName don't exist
 * @param {Function} props.onClick - onClick handler when user clicks on link
 * @param {string} props.className - className for styling
 * @returns {React.Component} - react component
 */
export default function ModalLink(_ref) {
  var dataAutomation = _ref.dataAutomation,
    postalCodeOrStoreName = _ref.postalCodeOrStoreName,
    toOrAtMessage = _ref.toOrAtMessage,
    fallbackMessage = _ref.fallbackMessage,
    _onClick = _ref.onClick,
    className = _ref.className;
  var linkMessage = postalCodeOrStoreName || fallbackMessage();
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className || '', " modal-link")
  }, postalCodeOrStoreName && /*#__PURE__*/React.createElement("span", {
    className: "to-or-at-message"
  }, "\xA0", toOrAtMessage(), "\xA0"), linkMessage ? /*#__PURE__*/React.createElement("button", {
    "data-automation": dataAutomation,
    className: "".concat(className || '', " link"),
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick();
    },
    type: "button"
  }, linkMessage) : undefined);
}
ModalLink.propTypes = {
  postalCodeOrStoreName: string,
  className: string,
  dataAutomation: string,
  fallbackMessage: func,
  toOrAtMessage: func,
  onClick: func
};